import type { PatientState } from '../types';

export const getPatientId = (get: () => PatientState) => get().patient.patientId;
export const getPatientCode = (get: () => PatientState) => get().patient.patientCode;
export const getPatient = (get: () => PatientState) => get().patient;
export const getPatientBasicInfo = (get: () => PatientState) => get().patient.basicInfo;
export const getPatientCareInfo = (get: () => PatientState) => get().patient.careInfo;
export const getPatientIdentificationInfo = (get: () => PatientState) => get().patient.identificationInfo;
export const getPatientRedFlagInfo = (get: () => PatientState) => get().patient.redFlagInfo;
export const getPatientContactDetails = (get: () => PatientState) => get().patient.contactDetails;
export const getPatientResidentialAddress = (get: () => PatientState) => get().patient.residentialAddress;
